

















































































import { GridOptions } from "ag-grid-community";
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";

/**
 * This component is built to add additional ag-grid-vue paging.
 * This is because ag-grid-vue doesn't allow multiple paging controls via a setting, so we can add a replica.
 */
@Component
export default class AgGridPagination extends Vue {
    @Prop({ required: true })
    gridOptions!: GridOptions;

    rowCount = 0;
    pageSize = 0;
    totalPages = 0;
    pageNumber = 0;

    get displayedRowCount() {
        const expectedRows = (this.pageNumber + 1) * this.pageSize;
        return this.rowCount > expectedRows ? expectedRows : this.rowCount;
    }

    mounted() {
        this.gridOptions.onPaginationChanged = e => {
            this.rowCount = e.api.paginationGetRowCount();
            this.pageSize = e.api.paginationGetPageSize();
            this.totalPages = e.api.paginationGetTotalPages();
            this.pageNumber = e.api.paginationGetCurrentPage();
        };
    }

    goToPage(i: number) {
        if (this.gridOptions.api) {
            this.gridOptions.api.paginationGoToPage(i);
        }
    }

    goToLastPage() {
        if (this.gridOptions.api) {
            this.gridOptions.api.paginationGoToLastPage();
        }
    }

    goToFirstPage() {
        if (this.gridOptions.api) {
            this.gridOptions.api.paginationGoToFirstPage();
        }
    }
}
